// Status marks for the Copilot cards (decorative: the words beside them say
// the same thing for screen readers).
import React from "react";
import { Spinner } from "./CardStyle";

export const DoneMark = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="8" fill="#E3F1EC" /><path d="M5.5 9.3l2.3 2.2 4.7-4.8" fill="none" stroke="#2E7D6B" strokeWidth="1.8" /></svg>
);
export const DoneSolid = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true" style={{ flex: "none" }}><circle cx="10" cy="10" r="9" fill="#2E7D6B" /><path d="M6 10.4l2.6 2.5L14 7.6" fill="none" stroke="#fff" strokeWidth="2" /></svg>
);
export const FailMark = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="8" fill="#F8E6E3" /><path d="M6.5 6.5l5 5M11.5 6.5l-5 5" stroke="#9B3F33" strokeWidth="1.8" /></svg>
);
export const FailSolid = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true" style={{ flex: "none" }}><circle cx="10" cy="10" r="9" fill="#B14B3E" /><path d="M7 7l6 6M13 7l-6 6" stroke="#fff" strokeWidth="2" /></svg>
);
export const WaitMark = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="7" stroke="#C9C7C5" strokeWidth="1.5" /></svg>
);
export const WarnMark = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="8" fill="#FDF0DE" /><path d="M9 5v5M9 12.5h.01" stroke="#9A4A06" strokeWidth="1.8" strokeLinecap="round" /></svg>
);
export const PersonMark = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="8" fill="#F1F0EF" /><circle cx="9" cy="7" r="2.2" stroke="#5E5B58" strokeWidth="1.4" /><path d="M5.2 13.2c.8-1.8 2.2-2.6 3.8-2.6s3 .8 3.8 2.6" stroke="#5E5B58" strokeWidth="1.4" /></svg>
);
export const UndoSolid = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true" style={{ flex: "none" }}><circle cx="10" cy="10" r="9" fill="#F1F0EF" /><path d="M6.5 8.5h5a2.5 2.5 0 010 5H9.5M6.5 8.5l2-2M6.5 8.5l2 2" stroke="#5E5B58" strokeWidth="1.6" /></svg>
);
export const RunningMark = () => <Spinner $size={16} />;
